﻿export const Login = (() => {

	const Init = () => {
		var email = document.getElementById('Input_Email') as HTMLInputElement;
		email.addEventListener('change', Submit);
		email.addEventListener('blur', Submit);
		email.addEventListener('focus', Submit);
		email.addEventListener('keydown', Submit);
	};

	const Submit = () => {
		var email = document.getElementById('Input_Email') as HTMLInputElement;

		if (email.value.indexOf('@physiocouncil.com.au') !== -1)
			(document.getElementById('staff-account') as HTMLFormElement)?.submit();
	};
    
    return { Init };

})();


document.addEventListener('DOMContentLoaded', () => {
	Login.Init();
});